import {IFailedLayerInfo} from '../interfaces/models'
import {ISourceDescription} from '../interfaces/models'

export class FailedServiceInfo implements IFailedLayerInfo {
  public sourceDescription: ISourceDescription
  public url: string
  public error: Error
  constructor(sourceDescription: ISourceDescription, error: Error) {
    this.sourceDescription = sourceDescription
    this.error = error
    this.url = sourceDescription.id
  }
}
